// ADDED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const salaryAdvanceAccessService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/AccessTemplate/salary-advance-access`, { headers });
  },

  update: async (id, payload) => {
    return await axios.put(`${domain}/api/AccessTemplate/salary-advance-access/${id}`, payload, { headers });
  },
};

export default salaryAdvanceAccessService;